import { AppFullscreen } from 'quasar'
import { computed } from 'vue'

export default function useFullscreen ($store) {
  async function exitFullscreen () {
    if (!AppFullscreen.isCapable) return
    const exited = await AppFullscreen.exit()
    $store.commit('App/ToggleDrawer', true)
    void $store.commit('App/SetFullscreen', false)
    void $store.commit('App/HideMobileNav', false)
    void $store.commit('App/HideFilters', false)
  }
  function exitHandler () {
    if (!document.fullscreenElement) {
      void exitFullscreen()
    }
  }
  return {
    isFullscreen: computed(() => $store.getters['App/IsFullscreen']),
    enter: async () => {
      try {
        if (!AppFullscreen.isCapable) return
        const entered = await AppFullscreen.request()
        $store.commit('App/ToggleDrawer', false)
        void $store.commit('App/SetFullscreen', true)
        void $store.commit('App/HideMobileNav', true)
        void $store.commit('App/HideFilters', true)
        document.addEventListener('fullscreenchange', exitHandler)
      } catch (e) {
        console.error(e)
      }
    },
    exit: async () => {
      try {
        await exitFullscreen()
        document.removeEventListener('fullscreenchange', exitHandler)
      } catch (e) {
        console.error(e)
      }
    }
  }
}
